/* tslint:disable */

declare var Object: any;
export interface AppPropertiesInterface {
  "id"?: number;
}

export class AppProperties implements AppPropertiesInterface {
  "id": number;
  constructor(data?: AppPropertiesInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `AppProperties`.
   */
  public static getModelName() {
    return "AppProperties";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of AppProperties for dynamic purposes.
  **/
  public static factory(data: AppPropertiesInterface): AppProperties{
    return new AppProperties(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'AppProperties',
      plural: 'app-properties',
      path: 'app-properties',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}
